export const discardedItemsActionsValues = {
  discard: 'discard',
  createNewShipment: 'create_new_shipment',
}

export const discardedItemsActionsOptions = [
  {
    value: discardedItemsActionsValues.discard,
    label: 'Descartar definitivamente (no se enviarán)',
  },
  {
    value: discardedItemsActionsValues.createNewShipment,
    label: 'Crear nuevo envío para más adelante',
  },
]
